import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@mui/styles';
import { Skeleton } from '@mui/material';
import { useIsSmartSuggestionSettingEnabled } from 'modules/timesheet-labels/hooks';
import { useGetDataSciencePerformanceAnalytics } from 'modules/Insights/Notes/hooks/useGetDataSciencePerformanceAnalytics';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: theme.spacing(0, 3),
    color: theme.palette.text.secondary,
    ...theme.typography.h6
  },
  percentage: {
    color: theme.palette.text.primary,
    marginLeft: theme.spacing(1)
  },
  skelton: {
    width: theme.spacing(10),
    display: 'inline-block',
    marginLeft: theme.spacing(1)
  },
  empty: {
    marginLeft: theme.spacing(1)
  }
}));

export const DataScienceAccuracy: React.FC = () => {
  const classes = useStyles();
  const isSmartSuggestionEnabled = useIsSmartSuggestionSettingEnabled();
  const { data, loading, isEmpty } = useGetDataSciencePerformanceAnalytics();

  const component = useMemo(() => {
    if (loading) return <Skeleton className={classes.skelton} variant="text" />;
    if (isEmpty)
      return (
        <span className={classes.empty}>
          <FormattedMessage id="insights.dataScience.accuracyNA" />
        </span>
      );

    const formattedValue = (
      (data?.dataSciencePerformanceAnalytics?.overallAccuracy || 0) * 100
    ).toFixed(2);

    return <span className={classes.percentage}>{`${formattedValue}%`}</span>;
  }, [
    classes,
    data?.dataSciencePerformanceAnalytics?.overallAccuracy,
    isEmpty,
    loading
  ]);

  if (!isSmartSuggestionEnabled) return <></>;

  return (
    <div data-testid="data-science-accuracy" className={classes.root}>
      <FormattedMessage id="insights.dataScience.accuracy" />
      {component}
    </div>
  );
};
